import { LoadingStates } from '@pb/utils'

import { RazorpayState } from '../types'

export const initialState: RazorpayState = {
  data: null,
  initStatus: LoadingStates.NotLoaded,
}
